<template>
  <div class="promotion_new">
    <div class="breadcrumb">
      <h1 style="color: #AC8400;">New Promotion</h1>
    </div>

    <!-- Breadcrumbs -->
    <div style="padding: 10px; background-color: #F2F2F2">
      <router-link to="/dashboard">
        Dashboard
      </router-link>
      /

      <b>Marketing</b> /

      <router-link to="/promotion">
        Promotions
      </router-link>
      /

      <b>New</b>
    </div>
    <!-- End of breadcrumbs -->

    <div class="separator-breadcrumb border-top"></div>

    <form class="form" @submit.prevent="handleSubmit">
      <div class="form-group">
        <label>Title</label>
        <input
          v-model="promotion.title"
          class="form-control"
          placeholder="Promotion Title ...."
        />
      </div>

      <div class="form-group">
        <label>Content</label>
        <textarea
          v-model="promotion.content"
          class="form-control"
          placeholder="Promotion Contents ...."
        ></textarea>
      </div>

      <div class="form-group">
        <label>Upload Image Link</label>
        <input
          type="file"
          id="file"
          ref="file"
          v-on:change="handleFileUpload"
          class="form-control"
        />
        <br />
        <progress max="100" :value.prop="uploadPercentage"></progress>
      </div>

      <div class="form-group">
        <small>
          <b>{{ promotion.created_at | moment("Do MMMM YYYY, h:mm a") }}</b>
        </small>
      </div>

      <input type="submit" class="btn btn-primary" />
    </form>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "promotion_new",

  data() {
    return {
      promotion: {
        title: "",
        content: ""
        // start_time: "",
        // end_time: ""
      },

      file: "",
      uploadPercentage: 0
    };
  },

  methods: {
    handleFileUpload() {
      this.file = this.$refs.file.files[0];
    },

    handleSubmit() {
      if (
        this.file !== "" &&
        this.promotion.title !== "" &&
        this.promotion.content !== ""
      ) {
        this.storePromotion();
      } else {
        swal({
          title: "Try Again",
          text: "All fields are required.",
          icon: "error"
        });
      }
    },

    storePromotion() {
      let token = localStorage.getItem("token");

      // check if has token
      if (token !== null) {
        token = JSON.parse(token);
        token = token.access_token;

        let formdata = new FormData();
        formdata.append("title", this.promotion.title);
        formdata.append("content", this.promotion.content);
        formdata.append("promotion", this.file);

        axios
          .post("/promotions/store", formdata, {
            headers: {
              Authorization: "Bearer " + token,
              "Content-Type": "multipart/form-data"
            },
            onUploadProgress: function(progressEvent) {
              this.uploadPercentage = parseInt(
                Math.round((progressEvent.loaded * 100) / progressEvent.total)
              );
            }.bind(this)
          })
          .then(res => {
            if (!res.data.success) {
              swal({
                text: res.data.message,
                icon: "error",
                button: "OK"
              });
            } else {
              swal({
                text: "Successful",
                icon: "success",
                button: "OK"
              });

              this.promotion.title = "";
              this.promotion.content = "";
            }
          });
      }
    }
  },

  mounted() {}
};
</script>
